import { atom } from 'jotai';
import { ALL_ITEMS, ITEMS_PER_PAGE } from '@/consts/interface';
import { ItemsPerPage } from '@/types/table';

export const pageAtom = atom(1);

export const itemsPerPageAtom = atom<ItemsPerPage | typeof ALL_ITEMS>(ITEMS_PER_PAGE[1]);
